/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR is the calories you'd burn at complete rest. TDEE is BMR scaled up for your daily activity — a better estimate of how much you actually need.`)
};

const es_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR son las calorías que quemarías en completo reposo. TDEE es BMR escalado según tu actividad diaria — una estimación mejor de cuántas calorías realmente necesitas.`)
};

const de_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR sind die Kalorien, die Sie in vollständiger Ruhe verbrennen würden. TDEE ist BMR hochskaliert für Ihre tägliche Aktivität — eine bessere Schätzung davon, wie viel Sie tatsächlich benötigen.`)
};

const nl_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR is de calorieën die u in volledige rust zou verbranden. TDEE is BMR opgeschaald voor uw dagelijkse activiteit — een betere schatting van hoeveel u werkelijk nodig hebt.`)
};

const fr_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le BMR est les calories que vous brûleriez au repos complet. TDEE est le BMR augmenté en fonction de votre activité quotidienne — une meilleure estimation de ce que vous avez réellement besoin.`)
};

const it_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR è le calorie che brucerai a completo riposo. TDEE è BMR scalato per la tua attività giornaliera — una stima migliore di quanto ne hai effettivamente bisogno.`)
};

const pt_br2_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR são as calorias que você queimaria em repouso completo. TDEE é BMR aumentado para sua atividade diária — uma estimativa melhor de quanto você realmente precisa.`)
};

const pt_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TMB são as calorias que queimaria em repouso completo. TDEE é a TMB aumentada para a sua atividade diária — uma melhor estimativa de quanto realmente precisa.`)
};

const ja_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMRは完全に安静時に燃焼するカロリー数です。TDEEは日次活動のためにスケールアップされたBMRです—実際に必要な量のより良い推定値です。`)
};

const zh_bmr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR 是您在完全静息状态下消耗的卡路里。TDEE 则是在 BMR 基础上根据您的日常活动量进行调整——能更准确地估算您实际所需的热量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq1_a", locale)
	if (locale === "en") return en_bmr_faq1_a(inputs)
	if (locale === "es") return es_bmr_faq1_a(inputs)
	if (locale === "de") return de_bmr_faq1_a(inputs)
	if (locale === "nl") return nl_bmr_faq1_a(inputs)
	if (locale === "fr") return fr_bmr_faq1_a(inputs)
	if (locale === "it") return it_bmr_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq1_a(inputs)
	if (locale === "pt") return pt_bmr_faq1_a(inputs)
	if (locale === "ja") return ja_bmr_faq1_a(inputs)
	return zh_bmr_faq1_a(inputs)
};